import { IResponse } from '@microsoft/portal-app/lib/odata-utils';
import { AnyPayload } from '@microsoft/portal-app/lib/redux/AnyPayload';
import { errorHandler } from '@microsoft/portal-app/lib/redux/observableErrorHandler';
import { MiddlewareAPI } from 'redux';
import { ActionsObservable, Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import { AjaxCreationMethod } from 'rxjs/observable/dom/AjaxObservable';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { getConvergedUXV2Url } from '../../../redux/modules/accountApis';
import { AccountActions, IAccountAction, IAccountState, IRootAccountState } from '../../models';
import { IConvergedUXV2Enabled } from '../../models/IConvergedUXV2Enabled';
import { accountRegistry as registry } from '../accountRegistry';

export const getConvergedUXV2Enabled: Epic<IAccountAction<AnyPayload>, IRootAccountState> = (
  action$: ActionsObservable<AnyPayload>,
  _store: MiddlewareAPI<IRootAccountState>,
  { ajax }: { ajax: AjaxCreationMethod }
): Observable<IAccountAction> => {
  return action$.ofType(AccountActions.getConvergedUXV2Enabled).pipe(
    mergeMap((action: IAccountAction) => {
      return ajax(getConvergedUXV2Url).pipe(
        map((payload: IResponse<boolean>) => {
          return {
            type: AccountActions.getConvergedUXV2EnabledResponse,
            payload: payload.response
          };
        }),
        catchError(errorHandler<IAccountAction>(AccountActions.getConvergedUXV2Failed, action))
      );
    })
  );
};
registry.addEpic(AccountActions.getConvergedUXV2Enabled, getConvergedUXV2Enabled);

export const getConvergedUXV2EnabledResponse = (
  state: IAccountState,
  action: IAccountAction<boolean>
): Readonly<IAccountState> => {
  if (action.payload === undefined) {
    return state;
  }

  const isConvergedUXV2Enabled: IConvergedUXV2Enabled = {
    isEnabled: action.payload,
    isLoading: false
  };

  return {
    ...state,
    isConvergedUXV2Enabled
  };
};
registry.add(AccountActions.getConvergedUXV2EnabledResponse, getConvergedUXV2EnabledResponse);
